import { render, staticRenderFns } from "./moreHNB.vue?vue&type=template&id=16a46afc&lang=pug&"
import script from "./moreHNB.vue?vue&type=script&lang=js&"
export * from "./moreHNB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports